import React, { useState } from "react";
import { Hotel } from "../../../assets/Services/wsSearch";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
  type CarouselApi,
} from "../../components/Carousel/Carousel";
import ImageWithFallback from "../../components/ImageWithFallback/ImageWithFallback";
import IconStar from "../../../assets/icons/IconStar";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/slices/userSlice";
import { useTranslation } from "react-i18next";
import { currencySymbols } from "../../../assets/Utils/prices";

type Props = {
  hotels: Hotel[];
  urlParams: URLSearchParams;
};

const UnavailableCarousel = (props: Props) => {
  const { hotels, urlParams } = props;

  const user = useSelector(selectUser);

  const { t } = useTranslation();

  const [carouselApi, setCarouselApi] = useState<CarouselApi>();

  return (
    <ul className="flex overflow-x-auto snap-x gap-3 w-screen lg:w-full px-4 sm:px-4 list-none">
      {hotels.map((hotel, index) => (
        <li
          key={`card-${index}-${hotel._id}`}
          className="flex flex-col min-w-[200px] w-[200px] gap-2 cursor-pointer"
          onClick={() => {
            if (hotel.slug) {
              return window.open(
                `${String(process.env.REACT_APP_FRONTEND_URI)}/${hotel.slug}${
                  urlParams ? `?${urlParams}` : ""
                }`,
                "_blank",
              );
            }
            window.open(
              `${String(process.env.REACT_APP_FRONTEND_URI)}/${hotel._id}${
                urlParams ? `?${urlParams}` : ""
              }`,
              "_blank",
            );
          }}
        >
          <div className="border border-[#E8E8E8] p-1 rounded-2xl shadow min-h-[200px]">
            <ImageWithFallback
              src={hotel.images[0].replace("square60", "square600")}
              alt={`${hotel.name} - ${index + 1}`}
              className="size-full object-cover rounded-xl"
            />
          </div>
          <div className="flex flex-col p-1">
            <p className="font-medium truncate text-ellipsis">{hotel.name}</p>
            <div className="flex flex-col gap-1 text-[#747474]">
              {!!hotel.reviewScore && !!hotel.reviewCount && (
                <div className="flex w-full justify-between items-center">
                  <p className="text-sm text-left flex items-center gap-1">
                    <span>{hotel.reviewScore}</span>
                    <IconStar className="size-2.5" />
                    <span>
                      {`(${new Intl.NumberFormat(user?.lang ?? "en-US").format(
                        hotel.reviewCount,
                      )})`}
                    </span>
                  </p>
                  {hotel.stars && Number(hotel.stars) !== 0 && (
                    <p className="text-sm text-left">
                      {`Hotel ${hotel.stars} ${t("ds.star", {
                        count: Number(hotel.stars),
                      })}`}
                    </p>
                  )}
                </div>
              )}
              {!(!!hotel.reviewScore && !!hotel.reviewCount) && (
                <p className="text-sm text-left flex items-center gap-1">
                  {t("ds.no_reviews_yet")}
                </p>
              )}
              {!!hotel.meanPrice ? (
                <>
                  <div className="horizontal-divider m-0 my-1"></div>
                  <div className="flex w-full justify-between items-center text-sm">
                    <p>Prezzo medio</p>
                    <p>
                      {new Intl.NumberFormat(user?.lang ?? "en-US").format(
                        Number(hotel.meanPrice.toFixed(0)),
                      )}
                      {
                        currencySymbols[
                          hotel.availability?.availabilityInfo.currency ?? "EUR"
                        ]
                      }
                      /notte
                    </p>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default UnavailableCarousel;
